import { useCallback } from 'react';
import { useLingui } from '@lingui/react/macro';
import { differenceInHours, differenceInMinutes } from 'date-fns';
import { useCurrentDateInTimezoneGetter } from './use-current-date-in-timezone-getter';

export const useRelativeTimeFormatter = () => {
  const getCurrentDateInTimezone = useCurrentDateInTimezoneGetter();
  const { t } = useLingui();

  return useCallback(
    (date: Date) => {
      const now = getCurrentDateInTimezone();
      const hours = differenceInHours(date, now);
      const minutes = (differenceInMinutes(date, now) || 1) % 60;

      return [
        {
          value: hours,
          unit: t({ message: 'h', context: 'short abbreviation for "hours"' })
        },
        {
          value: minutes,
          unit: t({ message: 'm', context: 'short abbreviation for "minutes"' })
        }
      ]
        .filter(({ value }) => !!value)
        .reduce((acc, { value, unit }) => `${acc} ${value}${unit}`, '');
    },
    [getCurrentDateInTimezone]
  );
};
